'use client';

import ErrorComponent from './_components/Error/Error';

import React from 'react';

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = (props) => <ErrorComponent {...props} />;

export default ErrorPage;
